$(document).ready(function(){
    var $ = require('jquery');

    var jQueryBridget = require('jquery-bridget');
    var Masonry = require('masonry-layout');
    var ekkoLightbox = require('ekko-lightbox');
    // make Masonry a jQuery plugin
    jQueryBridget( 'masonry', Masonry, $ );


    global.Tether = require('./vendor/tether.min.js');
    global.$ = require('jquery');

    require('./vendor/bootstrap.min');
	require("./custom/masonryWrapper");

    /*require("./vendor/owl.carousel.min.js");*/
    // require("./vendor/jquery.waitforimages.min");

    require("./custom/main");
    require("./custom/partner");
    require("./custom/forms");
    require("./custom/portfolio");
    require("./custom/lightbox");
	require("./custom/browser_selector");
	require("./custom/uploadModal");


    require('../scss/styles.scss');
});


